import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResultEntryRoutingModule } from './result-entry-routing.module';
import { ResultEntryComponent } from './pages';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import {FlexLayoutModule} from "@angular/flex-layout";
import {
  DxAccordionModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDrawerModule, DxFormModule,
  DxNumberBoxModule, DxPopoverModule, DxPopupModule, DxScrollViewModule,
  DxSelectBoxModule, DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule, DxValidationSummaryModule, DxValidatorModule
} from "devextreme-angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../../shared/shared.module";
import {ResultsModule} from "../results/results.module";
import { OrdersGridComponent } from './components/orders-grid/orders-grid.component';
import { ResultManagerComponent } from './components/result-manager/result-manager.component';
import {OrderService} from "./services/order.service";
import {OrdersDictionaryService} from "./components/result-manager/orders-dictionary.service";
import { MassResultEntryDialogComponent } from './components/mass-result-entry-dialog/mass-result-entry-dialog.component';


@NgModule({
  declarations: [
    ResultEntryComponent,
    SearchPanelComponent,
    OrdersGridComponent,
    ResultManagerComponent,
    MassResultEntryDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DxAccordionModule,
    DxDataGridModule,
    DxPopupModule,
    DxScrollViewModule,
    FlexLayoutModule,
    DxTextAreaModule,
    DxFormModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxButtonModule,
    DxToolbarModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxPopoverModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    DxDrawerModule,
    FlexLayoutModule,
    ResultEntryRoutingModule,
    SharedModule,
    ResultsModule
  ],
  providers: [
    OrderService,
    OrdersDictionaryService
  ]
})
export class ResultEntryModule { }
